<template>
    <div>
      <div class="form-group row d-flex align-items-center">
          <label class="col-lg-12 form-control-label">
              Related Photos
          </label>
          <div class="col-lg-12">
              <div class="row">
                <div v-for="questionImage in questionImages" :key="questionImage.image_id" class="col-sm-3 pb-3 entity-row-6">
                    <img v-if="questionImage.image" v-bind:src="cmsUrl + questionImage.image.image_url" class="img-fluid">
                    <img v-else v-bind:src="questionImage.data" class="img-fluid">
                    <div class="image-actions" v-if="!questionImage.image">
                        <button v-on:click="rotatePhoto(questionImage.image_id,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                        <button v-on:click="rotatePhoto(questionImage.image_id,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                    </div>
                    <button v-on:click="removePhoto(questionImage)" :disabled="isImageUploading" class="btn btn-outline-danger btn-square mt-3 w-100">Remove</button>
                </div>
              </div>
              <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                  <h3><span class="fa fa-spin fa-circle-notch"></span>
                      Adding image... Please wait...</h3>
              </div>
              <label class="fileContainer" v-if="questionImages.length < 4">
                  <span class="fa fa-camera"></span> Click to add an image
                  <input type="file" accept="image/*" @change="onPhotosChange" multiple>
              </label>
          </div>
      </div>
    </div>
</template>

<script>
    import ImageRotate from '@/components/mixins/ImageRotate.js';

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    export default {
        mixins: [ImageRotate],
        props: [
            'sectionImages',
            'imagesToDelete',
            'questionId'
        ],
        data() {
            return {
                isImageUploading: false,
                modifyingPhoto: false
            }
        },
        methods: {
            rotatePhoto(imageId, degrees) {
                this.modifyingPhoto = true;
                var imageIndex = this.sectionImages.findIndex((item) => item.image_id == imageId);
                if(imageIndex >= 0) {
                    this.rotateImage(this.sectionImages[imageIndex].data, degrees).then(newDataUri => {
                        this.sectionImages[imageIndex].data = newDataUri;
                        this.modifyingPhoto = false;
                    }).catch(e => {
                        console.log(e);
                        alert('Error occurred while trying to rotate photo');
                        this.modifyingPhoto = false;
                    });
                }
            },
            onPhotosChange(e) {
                if(this.questionImages.length >= 4) {
                    return;
                }
                this.isImageUploading = true;
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    this.isImageUploading = false;
                    return;
                }

                var vm = this;
                for(var i = 0; i < files.length; i++) {
                    if(i > 3) {
                        break;
                    }
                    this.isImageUploading = true;
                    var file = files[i];
                    EXIF.getData(file, function() {
                        var orientation = EXIF.getTag(this, "Orientation");
                        vm.createImage(this, orientation);
                    });
                }
            },
            createImage(file, orientation) {
                var compress = new Compress()
                var files = [file]
                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then(async (data) => {
                    var imgSrc = data[0].prefix + data[0].data;
                    var rotationDegrees = 0;
                    switch(orientation) {
                        case 3:
                            rotationDegrees = 180;
                            break;
                        case 6:
                            rotationDegrees = -90;
                            break;
                        case 8:
                            rotationDegrees = 90;
                            break;    
                    }

                    if(rotationDegrees != 0) {
                        await this.rotateImage(imgSrc, rotationDegrees).then(newDataUri => {
                            console.log('Image rotated');
                            imgSrc = newDataUri;
                        }).catch(e => {
                            console.log(e);
                        });
                    }

                    if(this.questionImages.length >= 4) {
                        this.isImageUploading = false;
                        return;
                    }

                    //console.log('Image added to array');
                    this.sectionImages.push({
                        'data': imgSrc, 
                        'alt': data[0].alt, 
                        'orientation': orientation, 
                        'image_id': this.$session.get('user_id').toString() + new Date().getTime() + data[0].alt,
                        'qid': this.questionId
                    });
                    this.isImageUploading = false;
                });
            },

            removePhoto(image) {
                if(image.image) {
                    for(var i = 1; i <= 19; i++) {
                        if(typeof image['ra_s'+i+'_image_id'] !== 'undefined') {
                            this.imagesToDelete.push(image['ra_s'+i+'_image_id']);
                            break;
                        }
                    }
                }
                var imageIndex = this.sectionImages.findIndex((item) => item.image_id == image.image_id);
                if(imageIndex >= 0) {
                    this.sectionImages.splice(imageIndex, 1);
                }
            },
        },
        computed: {
          questionImages() {
              var filteredImages = [];
              var vm = this;
              this.sectionImages.forEach(function(entry) {
                  if (entry.qid == vm.questionId)
                  {
                      filteredImages.push(entry);
                  }
              });
              return filteredImages;
          },
        }
    }
</script>